import { Fragment, useState } from 'react'
import { FormPhone, FormInput } from '../forms/final-form-fields'
import { defineMessages, useIntl } from 'react-intl'
import LoginPopup from '../popups/LoginPopup'
import RegistrationPopup from '../popups/RegistrationPopup'

const messages = defineMessages({
  firstName: {
    id: 'first_name',
    defaultMessage: 'First name',
  },
  lastName: {
    id: 'last_name',
    defaultMessage: 'Last name',
  },
  email: {
    id: 'email',
    defaultMessage: 'Email',
  },
  phone: {
    id: 'mobile-phone',
    defaultMessage: 'Mobile phone number',
  },
  requiredPhone: {
    id: 'requiredPhoneHint',
    defaultMessage:
      'Required so that the dive center can contact you if needed',
  },
  leadBooker: {
    id: 'leadBooker',
    defaultMessage: 'Lead Traveler / Booker',
  },
})

function LeadBookerInfo({ setPhoneRef, countryCode }) {
  const intl = useIntl()
  // const user = store('token')
  const [loginPopupIsOpen, showLoginPopup] = useState(false)
  const [registrationPopupIsOpen, showRegistrationPopup] = useState(false)
  const closeLoginPopup = () => showLoginPopup(false)
  const closeRegistrationPopup = () => showRegistrationPopup(false)
  // const showLoginModal = () => showLoginPopup(true)
  // const showRegistrationModal = () => showRegistrationPopup(true)
  return (
    <Fragment>
      <p className='section-title'>{intl.formatMessage(messages.leadBooker)}</p>
      <div className='shadow-block form-section'>
        {/* {!user && (
          <p className='reg-user'>
            <i className='font-icons people-icon' />
            <FormattedMessage
              id='login_or_register'
              values={{
                signIn: (
                  <a onClick={showLoginModal}>
                    <FormattedMessage id='sing_in' defaultMessage='Sign in' />
                  </a>
                ),
                register: (
                  <a onClick={showRegistrationModal}>
                    <FormattedMessage id='register' defaultMessage='Register' />
                  </a>
                ),
              }}
              defaultMessage='Want to book faster? {signIn} or {register} to easily manage your bookings'
            />
          </p>
        )} */}
        <div className='form-row'>
          <FormInput
            name='firstName'
            label={messages.firstName}
            isRequired
            placeholder={intl.formatMessage(messages.firstName)}
          />
          <FormInput
            name='lastName'
            label={messages.lastName}
            isRequired
            placeholder={intl.formatMessage(messages.lastName)}
          />
        </div>
        <div className='form-row'>
          <FormInput
            name='email'
            label={messages.email}
            isRequired
            placeholder={intl.formatMessage(messages.email)}
          />
          <FormPhone
            name='phone'
            label={messages.phone}
            isRequired
            getPhoneInstance={setPhoneRef}
            placeholder={intl.formatMessage(messages.phone)}
            hint={messages.requiredPhone}
            countryCode={countryCode}
          />
        </div>
      </div>
      <LoginPopup isOpen={loginPopupIsOpen} closeModal={closeLoginPopup} />
      <RegistrationPopup
        isOpen={registrationPopupIsOpen}
        closeModal={closeRegistrationPopup}
      />
    </Fragment>
  )
}

export default LeadBookerInfo
